export const priceWithSeparatorRegexp: RegExp = new RegExp(/\B(?=(\d{3})+(?!\d))/g);
